export async function handle(_path: string, _init?: RequestInit) {
  return { success: true };
}
